import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpService } from '@app/@core/services/http.service';
import { LocalService } from '@app/@core/services/local.service';
import { MenuItem } from 'primeng/api';
import { BehaviorSubject } from 'rxjs';
import { PageBuilderAddURL } from './page-builder-add-url.config';

export interface EmbedConfig {
  data : {
  reportId: string;
  workspaceId: string;
  embedUrl: string;
  embedToken: string;
  tokenExpiry: string;
  }
}

@Injectable({
  providedIn: 'root'
})
export class PageBuilderAddService {
  authorisedTabs: MenuItem[] = [];
  constructor(private httpService: HttpService, private router: Router, private localstore: LocalService) {
    // This is intentional
  }

  public getFormData = new BehaviorSubject<any>('');
  currentFormData = this.getFormData.asObservable();

  setFormData(data) {
    this.getFormData.next(data);
  }

  public getBasicData = new BehaviorSubject<any>('');
  currentBasicData = this.getBasicData.asObservable();

  setBasicData(data) {
    this.getBasicData.next(data);
  }

  public getPageType = new BehaviorSubject<any>(this.localstore.getObj('SELECTED_PAGE'));
  currentPageType = this.getPageType.asObservable();

  setPageType(data: string) {
    this.getPageType.next(data);
  }

  getBasicDetailsbyId(id) {
    return this.httpService.get(PageBuilderAddURL.EndPoints.page_config.pageVersion.replace('{id}', id));
  }
  pageAlertChecking(pagename: any, orgid: any, _body?: any) {
    return this.httpService.post(
      PageBuilderAddURL.EndPoints.page_config.pageExist
        .replace('{pagename}', String(pagename))
        .replace('{orgid}', String(orgid)),
      _body
    );
  }

  createPage(data: any) {
    return this.httpService.post(PageBuilderAddURL.EndPoints.page_config.page + '/', data);
  }
  createAssetByVersion(pageid: any, versionid: any, assetData: any) {
    return this.httpService.post(
      PageBuilderAddURL.EndPoints.page_config.assetByVersion
        .replace('{pageid}', String(pageid))
        .replace('{versionid}', String(versionid)),
      assetData
    );
  }

  getMenuList(data, id) {
    return this.httpService.post(PageBuilderAddURL.EndPoints.rbac.asset.batch + id, data);
  }

  getTableFields(param1, param2) {
    return this.httpService.get(PageBuilderAddURL.EndPoints.page_config.dbSchema + param1 + '/' + param2 + '/true/');
  }

  createReportTable(data) {
    return this.httpService.post(PageBuilderAddURL.EndPoints.report.report + '/', data);
  }

  getAllPage(url) {
    return this.httpService.get(url);
  }

  getSchema() {
    return this.httpService.get(PageBuilderAddURL.EndPoints.page_config.dbSchema);
  }

  getAllOrganisations() {
    return this.httpService.get(PageBuilderAddURL.EndPoints.rbac.organization.list + 'all');
  }

  editPageStatus(data, id) {
    return this.httpService.post(PageBuilderAddURL.EndPoints.page_config.page_lock.replace('{id}', String(id)), data);
  }

  getOrgList(orgid) {
    return this.httpService.get(PageBuilderAddURL.EndPoints.page_config.orgPageList.replace('{orgid}', orgid));
  }

  getUploadKey(data) {
    return this.httpService.post(PageBuilderAddURL.EndPoints.attachment.uploadKey, data);
  }

  getFormResponseAttachment(formid, responseid) {
    return this.httpService.get(
      PageBuilderAddURL.EndPoints.attachment.list.replace('{formid}', formid).replace('{responseid}', responseid)
    );
  }

  deleteFormResponseAttachment(fileid) {
    return this.httpService.delete(PageBuilderAddURL.EndPoints.attachment.delete.replace('{fileid}', fileid));
  }

  downloadFormResponseAttachment(data) {
    return this.httpService.post(PageBuilderAddURL.EndPoints.attachment.downloadKey, data);
  }
  returnToList() {
    this.router.navigate(['/pages/page-design/list']);
  }
  getEmbedConfig(): Promise<EmbedConfig> {
    return this.httpService.get<EmbedConfig>(PageBuilderAddURL.EndPoints.powerbi.embedConfig).toPromise();
  }
}
